import vue from 'vue';

export default function buildOneCRecordStore(store){
    store.actions.setRecordState = async (context, payload) => await vue.prototype.$myHttp.post('api/OneCRecords/setRecordState', payload);
    store.actions.saveComment = async (context, payload) => await vue.prototype.$myHttp.post('api/OneCRecords/saveComment', payload);
    return store;
}
